import { createSelector } from 'reselect';

export const siteConfSelector = state => state.siteConfReducer.siteConf;
export const mainEventColorSelector = state => state.siteConfReducer.siteConf.color1;

export const color1Selector = createSelector(
    siteConfSelector,
    (siteConf) => siteConf.color1
);
